import * as React from "react";
import {Suspense} from "react";
import {Accordion as BootstrapAccordion, Table} from "react-bootstrap";
import {CompatibleWith} from "../components/compatibleWith";
import {Specifications as ProductSpecifications} from "../components/specifications";
import Skeleton from "react-loading-skeleton";
import {useAccordionItemBodyStatus} from "../../../../../hooks/useAccordionItemBodyStatus";
import {useAccordionVariables} from "../../../../../hooks/useAccordionVariables";
import {AccordionItemType} from "../../../../../definitions/enums";
import {ErrorBoundary} from "@sentry/react";

export const Specifications = () => {
    return (
        <ErrorBoundary fallback={<></>}>
            <Header/>
            <Body/>
        </ErrorBoundary>
    )
}

const Header = () => {
    const {onClick} = useAccordionVariables();
    return (
        <BootstrapAccordion.Header className="fs-3" onClick={() => onClick(AccordionItemType.Specifications)}>
            Specifications
        </BootstrapAccordion.Header>
    )
}

const Body = () => {
    const {hasEntered, onEnter} = useAccordionItemBodyStatus();

    return (
        <BootstrapAccordion.Body onEnter={onEnter}>
            {hasEntered && (
                <Suspense fallback={<SkeletonBody/>}>
                    <ProductSpecifications/>
                    <CompatibleWith/>
                </Suspense>
            )}
        </BootstrapAccordion.Body>
    );
};

const SkeletonBody = () => {
    return (
        <>
            <div className="product-specifications">
                <Table striped>
                    <tbody>
                    <SkeletonTableRow/>
                    <SkeletonTableRow/>
                    <SkeletonTableRow/>
                    <SkeletonTableRow/>
                    <SkeletonTableRow/>
                    </tbody>
                </Table>
            </div>
            <div className="mb-3 mb-3 ">
                <span className="fw-bold me-1">
                    <Skeleton count={2}/>
                </span>
            </div>
        </>
    )
}

const SkeletonTableRow = () => (
    <tr>
        <SkeletonTableHeader/>
        <SkeletonTableData/>
        <SkeletonTableHeader/>
        <SkeletonTableData/>
    </tr>
);

const SkeletonTableHeader = () => <th><Skeleton/></th>;

const SkeletonTableData = () => <td><Skeleton/></td>;